module.exports = __webpack_public_path__ + "img/robot.df326b31.svg";